<template>
  <div id="services" class="container-fluid">
    <div class="skg-wording">
      <h1 class="text-center padding-div">We offer a wide range of services</h1>
      <div class="row flex-column-reverse flex-lg-row pt-2">
        <div class="col-12 col-lg-6 zero-padding">
          <img
            src="../assets/modern_kitchen.jpg"
            class="img-fluid"
            alt="Picture of modern kitchen from a recent project"
          />
        </div>
        <div class="col-12 col-lg-6">
          <h5 class="pt-3 pr-3 pl-3">
            From conception to completion, our team makes our clients' needs a
            priority. We have experience in a wide variety of projects to better
            serve you.
            <li class="pt-2">New Construction</li>
            <li>Remodel and Additions</li>
            <li>Commercial Construction</li>
            <li>Metal Buildings</li>
            <li>Shops / Barns</li>
            <li>Concrete Patios and Driveways</li>
            <li>Foundations</li>
            <li>Roofing</li>
            <li>Ag Buildings</li>
            <li>Windows and Doors</li>
            <li>Siding</li>
            <li>Patio Covers</li>
            <li class="pb-3">Gazebos</li>
            Licensed, Bonded, and Insured General Contractor providing services
            in Nyssa, Adrian, Vale, and Ontario, Oregon.
          </h5>
          <h5 class="pl-3 pr-3 pb-3 pt-2">
            Ranked in the top 8% of Oregon Licensed Contractors according to
            BuildZoom Ratings.
          </h5>
        </div>
      </div>
    </div>
    <div class="div-hr-padding">
      <hr class="div-hr" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>